// Status of the connection with the server
export enum ConnectionStatus {
	Connected,
	Reconnecting,
	Disconnected,
}
